import React, {
  useState,
  //forwardRef,
  useContext,
  useEffect,
  Fragment,
} from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Search, Assignment, AddCircle, Edit } from "@material-ui/icons";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import format from "date-fns/format";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Box from "@material-ui/core/Box";

import imgLoader from "assets/img/progress.gif";
import NewStudentAdmin from "views/dialog/NewStudentAdmin";
import ViewStudent from "views/dialog/ViewStudent";
import EditStudent from "views/dialog/EditStudent";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function StudentAdminList() {
  const classes = useStyles();
  //const tableRef = React.createRef();

  const [rows, setRows] = useState([]);
  const [openNew, setopenNew] = useState(false);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [openView, setopenView] = useState(false);
  const [idRow, setIdRow] = useState("");
  const [openEdit, setOpenEdit] = useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  /*const tableIcons = {
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  };*/

  const [state] = useState({
    columns: [
      {
        headerName: "Nombres",
        field: "allnames",
        flex: 1,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Identificacion",
        field: "identificacion",
        width: 120,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Correo personal",
        field: "correo_personal",
        flex: 1,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      /*{
        headerName: "Celular",
        field: "celular",
        width: 120,
        headerAlign: "center",
        align: "center",
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Fecha nacimiento",
        field: "fecha_nacimiento",
        renderCell: (params) => {
          return <>{format(new Date(params.value), "dd-MM-yyyy")}</>;
        },
        width: 140,
        headerAlign: "center",
        align: "center",
        filtering: false,
        sortable: false,
        hideable: false,
      },*/
      {
        headerName: "Registro",
        field: "createdAt",
        renderCell: (params) => {
          return <>{format(new Date(params.value), "dd-MM-yyyy")}</>;
        },
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        width: 100,
        align: "center",
        filtering: false,
        sortable: false,
        hideable: false,
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 110,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => [
          <GridActionsCellItem
            icon={
              <Tooltip title="Ver factura" arrow>
                <Search sx={{ fontSize: 24 }} />
              </Tooltip>
            }
            label="Ver facturas"
            sx={{ color: "#000" }}
            onClick={ViewData(params)}
          />,
          <GridActionsCellItem
            icon={
              <Tooltip title="Editar" arrow>
                <Edit sx={{ fontSize: 24 }} />
              </Tooltip>
            }
            label="Editar"
            sx={{ color: "#000" }}
            onClick={EditData(params)}
          />,
        ],
      },
    ],
  });

  useEffect(() => {
    dataRows();
  }, []);

  const dataRows = async () => {
    try {
      await axios
        .get(
          `${urlServices}routes_student.php?keyAplication=${keyAplication}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          if (response.data.code === 1) {
            setRows(response.data.data);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          } else if (response.data.code === 0) {
            setRows([]);
            setLoader(false);
          }
        })
        .catch((e) => {
          setRows([]);
          setError(true);
          setLoader(false);
          console.log(e);
        });
    } catch (error) {
      // console.log("ENTROOOOOOOO2");
      setError(true);
      setRows([]);
      setLoader(false);
      console.error(error);
      throw error;
    }
  };

  const ViewData = (data) => () => {
    setIdRow(data.row);
    setopenView(true);
  };

  const EditData = (data) => () => {
    setIdRow(data.row);
    setOpenEdit(true);
  };

  const RefreshTable = () => {
    dataRows();
  };

  const handleCloseNew = () => {
    setopenNew(false);
  };

  const handleCloseView = () => {
    setopenView(false);
  };

  const handleCloseOpenEdit = () => {
    setOpenEdit(false);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info">
            <div className={classes.cardTitleWhite}>
              <Assignment className={classes.iconWhite} /> Listado de
              estudiantes
            </div>
          </CardHeader>
          <CardBody>
            {error && (
              <Alert severity="error">
                Error en la consulta con sel servidor.
              </Alert>
            )}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      src={imgLoader}
                      alt="loader"
                      style={{
                        width: 50,
                        margin: "100px 0",
                        objectFit: "contain",
                      }}
                    />
                  </center>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                <Grid container>
                  <Grid item xs={12} sm={12}>
                    <Button
                      className={classes.buttonRight}
                      onClick={(event) => {
                        setopenNew(true);
                      }}
                      startIcon={<AddCircle />}
                    >
                      Agregar estudiante
                    </Button>
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    "& .super-app.celAll": {
                      fontSize: 12,
                      //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                    },
                    "& .super-app.celActions": {
                      backgroundColor: "rgb(242, 242, 242)",
                    },
                    "& .super-app-theme--header": {
                      backgroundColor: "rgb(242, 242, 242)",
                    },
                  }}
                >
                  <DataGrid
                    rows={rows}
                    columns={state.columns}
                    loading={loader}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                      },
                    }}
                    pageSizeOptions={[5, 10, 20, 50]}
                    disableRowSelectionOnClick={true}
                    checkboxSelection={false}
                    //rowHeight={40}
                    autoHeights
                  />
                </Box>
                {/* <MaterialTable
                  title=""
                  tableRef={tableRef}
                  columns={state.columns}
                  style={{
                    boxShadow: "unset",
                    border: "1px solid rgb(241, 241, 241)",
                  }}
                  data={rows}
                  localization={{
                    pagination: {
                      labelRowsSelect: "Filas",
                      labelDisplayedRows: " {from}-{to} de {count}",
                      firstTooltip: "Primera página",
                      previousTooltip: "Previo",
                      nextTooltip: "Siguiente",
                      lastTooltip: "Ultima página",
                    },
                    toolbar: {
                      // nRowsSelected: '{0} row(s) selected',
                      searchTooltip: "Filtrar",
                      searchPlaceholder: "Buscar",
                    },
                    header: {
                      actions: " --- ",
                    },
                    body: {
                      emptyDataSourceMessage: "No hay datos.",
                      filterRow: {
                        filterTooltip: "Filtro",
                      },
                    },
                  }}
                  actions={[
                    {
                      icon: "search",
                      tooltip: "Ver",
                      onClick: (event, rowData) => {
                        setopenView(true);
                        setIdRow(rowData);
                      },
                    },
                    {
                      icon: "edit",
                      tooltip: "Editar",
                      onClick: (event, rowData) => {
                        setOpenEdit(true);
                        setIdRow(rowData);
                      },
                    },
                  ]}
                  icons={tableIcons}
                  options={{
                    search: true,
                    padding: "default",
                    filtering: false,
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    headerStyle: {
                      background: "#F2F2F2",
                      padding: "1%",
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: 12,
                    },
                    cellStyle: { border: "1px solid #DDDDDD" },
                  }}
                />*/}
              </Fragment>
            )}
          </CardBody>
        </Card>
      </GridItem>
      {openView && (
        <ViewStudent open={openView} exit={handleCloseView} id={idRow} />
      )}
      {openNew && (
        <NewStudentAdmin
          open={openNew}
          exit={handleCloseNew}
          callBackRefresh={RefreshTable}
        />
      )}
      {openEdit && (
        <EditStudent
          open={openEdit}
          exit={handleCloseOpenEdit}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
    </GridContainer>
  );
}
